const SUPPORT_CENTER_LINK = 'https://service.elsevier.com/app/home/supporthub/reaxys/';

export default SUPPORT_CENTER_LINK;
